import React, { useState, useEffect } from 'react';
import { Modal } from '@vectord/components';

import analytics from 'utils/analytics';
import Loader from 'components/Loader';
import styles from './ASLVideoUploadWaitModal.module.scss';

export default function ASLVideoUploadWaitModal({
  totalFiles,
  uploadedFiles: filesUploaded,
}) {
  const [count, setUploadedFiles] = useState(filesUploaded || 0);
  const percentageComplete = Math.round((count / totalFiles) * 100);

  useEffect(() => {
    if (filesUploaded !== undefined && filesUploaded <= totalFiles) {
      setUploadedFiles(filesUploaded);
    }
  }, [filesUploaded, totalFiles]);

  return (
    <Modal
      isOpen
      size="large"
      title="Please do not refresh the page until the upload is complete."
      unMountOnClose
      hasCloseButton={false}
      onClose={() => {
        analytics.click({
          click_type: 'Bulk Upload Video Modal Close Clicked',
        });
      }}
    >
      <div className="m-t-10">
        <Loader />
        <div className="m-t-10">
          <div
            className={styles.progressBar}
            style={{ width: `${2 + percentageComplete}%` }}
          />
        </div>
        <div className="m-t-10">
          {percentageComplete}% complete - Please do not refresh the page until
          the upload is complete
        </div>
      </div>
    </Modal>
  );
}
